import { OnInit, Input, Directive } from '@angular/core';

@Directive()
export abstract class PolicyStatusComponent {
  @Input() status: any;
}
